import { createFileRoute, Link } from "@tanstack/react-router";

import { Page, QuoteForm } from "../components/site";
import { SITE, diensten, plaatsen } from "../lib/seo-data";

export const Route = createFileRoute("/diensten")({
  head: () => ({
    meta: [
      { title: "Diensten van elektriciens & richtprijzen | offerto" },
      {
        name: "description",
        content:
          "Groepenkast vervangen, laadpaal installeren, stopcontacten bijplaatsen of herbedraden: bekijk richtprijzen en vraag gratis offertes aan.",
      },
      { property: "og:title", content: "Diensten van elektriciens & richtprijzen" },
      {
        property: "og:description",
        content:
          "Richtprijzen per klus en gratis offertes van erkende elektriciens bij jou in de buurt.",
      },
      { property: "og:type", content: "website" },
      { property: "og:url", content: `${SITE}/diensten` },
      { property: "og:locale", content: "nl_NL" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: `${SITE}/diensten` }],
  }),
  component: Diensten,
});

function Diensten() {
  return (
    <Page
      title="Vind dé elektricien voor je project"
      intro="Bekijk per klus wat je ongeveer betaalt en vergelijk gratis en vrijblijvend offertes van meerdere betrouwbare elektriciens uit jouw regio."
    >
      <div className="mt-12 grid gap-6 md:grid-cols-2">
        {diensten.map((s) => (
          <Link
            key={s.slug}
            to="/elektricien/$dienst"
            params={{ dienst: s.slug }}
            className="min-w-0 rounded-lg border border-border bg-card p-6 transition-colors hover:border-primary"
          >
            <div className="flex items-baseline justify-between gap-4 max-[400px]:flex-col max-[400px]:items-start max-[400px]:gap-1">
              <h2 className="text-xl font-bold">{s.naam}</h2>
              <span className="whitespace-nowrap text-sm font-bold text-primary">{s.prijs}</span>
            </div>
            <p className="mt-3 text-sm text-muted-foreground">{s.kort}</p>
          </Link>
        ))}
      </div>

      <h2 className="mt-16 text-2xl font-bold">Elektricien per plaats</h2>
      <ul className="mt-5 grid gap-2 text-sm sm:grid-cols-3 lg:grid-cols-4">
        {plaatsen.map((p) => (
          <li key={p.slug}>
            <Link
              to="/plaatsen/$plaats"
              params={{ plaats: p.slug }}
              className="text-muted-foreground hover:text-primary"
            >
              Elektricien {p.naam}: tarieven en voorrijkosten
            </Link>
          </li>
        ))}
      </ul>

      <div className="mt-12">
        <QuoteForm />
      </div>
    </Page>
  );
}
